<template>
  <div class="product-recommended">
    <div class="pt-5">
      <div class="pl-md-5 text-md-h6 text-uppercase black--text">{{ title }}</div>
    </div>
    <div class="pt-4 pb-5" v-if="product.length > 0">
      <carousel
        :loop="false"
        :responsive="{ 0: { items: 2 }, 600: { items: 4 }, 1000: { items: 6 } }"
        :nav="false"
        :dots="false"
        :margin="5"
      >
        <div class="pa-1" v-for="(item, index) in product" :key="index">
          <v-hover v-slot:default="{ hover }">
            <router-link
              :to="{
                name: 'product-detail',
                params: { slug: item.product_slug_name, id: item.product_id }
              }"
              class="text-deco"
            >
              <v-card outlined class="rounded-lg" :elevation="hover ? 4 : 0">
                <div class="pa-3">
                  <v-img
                    :src="
                      item.product_image[0] ? item.product_image[0] : '/assets/product/default.png'
                    "
                    height="150"
                    class="rounded-lg"
                  ></v-img>
                </div>
                <v-col class="grey--text text--darken-2 px-2">
                  <div class="text-body-2 product-name">{{ item.product_name }}</div>
                  <div class="product-price mt-2">
                    <div
                      class="text-decoration-line-through font-size-12 pink--text"
                      v-if="item.product_price != item.product_price_origin"
                    >
                      Rp {{ item.product_price_origin | toNumber }}
                    </div>
                    <div class="text-subtitle-1 pt-1 font-weight-bold">
                      Rp {{ item.product_price | toNumber }}
                    </div>
                  </div>
                  <!--<div>
										<v-icon small color="yellow darken-1" v-for="i in 5" :key="i+'itemStar'+item.product_id">mdi-star</v-icon>
										<span class="pl-1 text-caption">({{item.product_view_count | toNumber}})</span>
                  </div>-->
                  <div v-if="false">
                    <v-icon
                      small
                      color="yellow darken-1"
                      v-for="i in fullRating(item.product_rating)"
                      :key="'full' + i"
                      >mdi-star</v-icon
                    >
                    <v-icon
                      small
                      color="yellow darken-1"
                      v-if="halfRating(item.product_rating, item.product_review_count)"
                      >mdi-star-half-full</v-icon
                    >
                    <v-icon
                      small
                      color="yellow darken-1"
                      v-for="i in nullRating(item.product_rating)"
                      :key="'half' + i"
                      >mdi-star-outline</v-icon
                    >
                    <!-- <v-rating empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half-full" hover length="5" readonly size="12" color="yellow darken-1" :value="parseInt(product.product_rating) / parseInt(product.product_review_count)"></v-rating> -->
                    <span class="pl-1 text-caption"
                      >({{ item.product_review_count | toNumber }})</span
                    >
                  </div>
                  <div class="text-caption">
                    <span v-if="item.product_enable_discount == '1'" class="red white--text"
                      >{{ item.product_discount_percent | toNumber }}%</span
                    >
                    &nbsp;
                    <strike v-if="item.product_enable_discount == '1'"
                      >Rp {{ item.product_gross | toNumber }}</strike
                    >
                  </div>
                  <!-- <div class="text-caption" v-if="item.am.product_fee > 0">
                    <b> GM: Rp {{ item.am.total | toNumber }} </b>
                  </div> -->
                  <div class="text-caption">{{ item.product_sold_count | toNumber }} terjual</div>
                </v-col>
              </v-card>
            </router-link>
          </v-hover>
        </div>
        <template slot="prev">
          <v-card elevation="0" class="col-12 pa-0">
            <v-btn x-small color="white" elevation="3" fab class="prev prev-other-product">
              <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
            </v-btn>
          </v-card>
        </template>
        <template slot="next">
          <v-card elevation="0" class="col-12 pa-0">
            <v-btn x-small color="white" elevation="3" fab class="next next-other-product">
              <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
            </v-btn>
          </v-card>
        </template>
      </carousel>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  components: {
    carousel
  },
  computed: {
    title() {
      switch (this.type) {
        case "recomended":
          return "REKOMENDASI PRODUK LAINNYA";

        case "byStore":
          return "PRODUK LAINNYA DI TOKO INI";

        default:
          return "PRODUK TERBAIK";
      }
    }
  },
  props: {
    type: String,
    product: Array
  }
};
</script>
